module.exports = {"title":"Tickets Assignment","both":"Patron and Box Office","boxOfficeOnly":"Box Office only","noOne":"No one","saveClose":"Save and Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/DatesModal/locales/en.json
// module id = 1662
// module chunks = 0